var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"q10__page my-14"},[_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"q10__article_container__article_tour card"},[_c('article-title-tour',{attrs:{"options":{
                    tourtitle: _vm.currentPage.content.tourTitle.text,
                    titlecolor: 'text-selective_green',
                    toursubtitle: _vm.currentPage.content.tourSubTitle.text,
                    subtitlecolor: 'text-nandor',
                }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"-top-3 md:top-0 -right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Renouv’Eau, l’interview de JF Astolfi'
                            ),
                        }}})],1),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.secondYear.text,
                        pretitle: _vm.currentPage.content.secondPreTitle.text,
                        title: _vm.currentPage.content.secondTitle.text,
                        content: _vm.currentPage.content.secondText.text,
                        fontSize: {},
                        color: {
                            year: 'text-selective_orange',
                            title: 'text-selective_green',
                            subtitle: 'text-red-500',
                            content: 'text-black',
                        },
                        fontSize: {
                            year: 'text-md md:text-lg lg:text-xl',
                            pretitle: 'text-xl 2xl:text-2xl',
                            title: 'text-3xl 2xl:text-4xl',
                            subtitle: 'text-2xl md:text-2xl lg:text-3xl',
                            content: 'text-md md:text-xl lg:text-base',
                        },
                    }}},[_c('div',{staticClass:"mx-auto"},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image2.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image2
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    } ],
                            }}})],1)])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"-top-3 md:top-0 -right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Mulhouse déménage rue des Pâturages'
                            ),
                        }}})],1),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.firstYear.text,
                        pretitle: _vm.currentPage.content.firstPreTitle.text,
                        title: _vm.currentPage.content.firstTitle.text,
                        content: _vm.currentPage.content.firstText.text,
                        fontSize: {},
                        color: {
                            year: 'text-selective_orange',
                            title: 'text-selective_green',
                            content: 'text-black',
                        },
                        fontSize: {
                            year: 'text-md md:text-lg lg:text-xl',
                            pretitle: 'text-xl 2xl:text-2xl',
                            title: 'text-3xl 2xl:text-4xl',
                            content: 'text-md md:text-xl lg:text-base',
                            outerText: 'text-md',
                        },
                    }}},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image1.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image1.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-xs md:text-base',
                                } ],
                        }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{attrs:{"options":{
                            image500:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image3.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image3.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-xs md:text-base',
                                } ],
                        }}})],1),_c('div',{staticClass:"absolute top-0 left-0 p-8"},[_c('TimelineTitle',{attrs:{"options":{
                            year: _vm.currentPage.content.thirdYear.text,
                            title: _vm.currentPage.content.thirdTitle.text,
                            subtitle:
                                _vm.currentPage.content.thirdSubTitle.text,
                            content: _vm.currentPage.content.thirdText.text,

                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                title: 'text-4xl md:text-3xl lg:text-6xl',
                                subtitle: 'text-2xl 2xl:text-3xl',
                                content: 'text-md md:text-xl lg:text-base',
                            },
                            color: {
                                year: 'text-selective_orange',
                                pretitle: 'text-white',
                                title: 'text-white',
                                subtitle: 'text-white',
                                content: 'text-white',
                            },
                        }}})],1)]),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"-top-3 md:top-0 -right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Lancement des journées d’accueil des nouveaux arrivants en 2008'
                            ),
                        }}})],1),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.fourthYear.text,
                        pretitle: _vm.currentPage.content.fourthPreTitle.text,
                        title: _vm.currentPage.content.fourthTitle.text,
                        content: _vm.currentPage.content.fourthText.text,
                        fontSize: {},
                        color: {
                            year: 'text-selective_orange',
                            title: 'text-selective_green',
                            subtitle: 'text-red-500',
                            content: 'text-black',
                        },
                        fontSize: {
                            year: 'text-md md:text-lg lg:text-xl',
                            pretitle: 'text-xl 2xl:text-2xl',
                            title: 'text-3xl 2xl:text-4xl',
                            subtitle: 'text-2xl md:text-2xl lg:text-3xl',
                            content: 'text-md md:text-xl lg:text-base',
                        },
                    }}},[_c('div',{staticClass:"mx-auto"},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image4
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    } ],
                            }}})],1)])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative pt-6 md:pt-8 lg:pt-0"},[_c('hotspot-richmedia',{staticClass:"top-2 md:top-0 2xl:top-12 -right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Évolution de l’organisation du CIH en 2008'
                            ),
                        }}})],1),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.fifthYear.text,
                        pretitle: _vm.currentPage.content.fifthPreTitle.text,
                        title: _vm.currentPage.content.fifthTitle.text,
                        content: _vm.currentPage.content.fifthText.text,
                        fontSize: {},
                        color: {
                            year: 'text-selective_orange',
                            title: 'text-selective_green',
                            content: 'text-black',
                        },
                        fontSize: {
                            year: 'text-md md:text-lg lg:text-xl',
                            pretitle: 'text-xl 2xl:text-2xl',
                            title: 'text-3xl 2xl:text-4xl',
                            content: 'text-md md:text-xl lg:text-base',
                        },
                    }}},[_c('div',{staticClass:"mx-auto"},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image5
                                            .text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    } ],
                            }}})],1)])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                                year: _vm.currentPage.content.sixthYear.text,
                                pretitle:
                                    _vm.currentPage.content.sixthPreTitle.text,
                                title: _vm.currentPage.content.sixthTitle.text,
                                content: _vm.currentPage.content.sixthText.text,
                                fontSize: {},
                                color: {
                                    year: 'text-selective_orange',
                                    title: 'text-selective_green',
                                    content: 'text-black',
                                },
                                fontSize: {
                                    year: 'text-md md:text-lg lg:text-xl',
                                    pretitle: 'text-xl 2xl:text-2xl',
                                    title: 'text-3xl 2xl:text-4xl',
                                    content:
                                        'text-md md:text-xl lg:text-base',
                                },
                            }}},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.image6.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.image6
                                                .text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize:
                                                'text-xs md:text-base',
                                        } ],
                                }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                                year: _vm.currentPage.content.seventhYear.text,
                                pretitle:
                                    _vm.currentPage.content.seventhPreTitle
                                        .text,
                                title: _vm.currentPage.content.seventhTitle
                                    .text,
                                content:
                                    _vm.currentPage.content.seventhText.text,
                                fontSize: {},
                                color: {
                                    year: 'text-selective_orange',
                                    title: 'text-selective_green',
                                    subtitle: 'text-red-500',
                                    content: 'text-black',
                                },
                                fontSize: {
                                    year: 'text-md md:text-lg lg:text-xl',
                                    pretitle: 'text-xl 2xl:text-2xl',
                                    title: 'text-3xl 2xl:text-4xl',
                                    subtitle:
                                        'text-2xl md:text-2xl lg:text-3xl',
                                    content:
                                        'text-md md:text-xl lg:text-base',
                                },
                            }}})],1)])]),_c('timeline-carousel',{attrs:{"options":{
            timeline: _vm.currentPage.timeline,
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }